module.exports = __webpack_public_path__ + "kit_1_header_faded.jpg?0410de83b53ba40872e9bc7f14ed7c7c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kit_1_header_faded.jpg
// module id = 77
// module chunks = 0